module.exports = __webpack_public_path__ + "img/maze_oval_g.0c8dee74.svg";